import { useRef } from 'react'
import { useDrag, useDrop, DropTargetMonitor } from 'react-dnd'
import { Trash } from '@astronautsid/wpe-icons'
import { Typography } from '@astro-ui/components'
import { ProductImageType } from 'features/Product/redux/ProductAddEdit'
import { StyledOverlay, StyledIconButton, StyledBoxImage } from './style'

type ImageItemPropsType = {
  index: number
  imageSrc: string
  onClickBtnDelete: (index: number) => void
  moveImage: (dragIndex: number, hoverIndex: number) => void
}

const PRODUCT_IMAGE = 'PRODUCT_IMAGE'

const ImageItem = ({ index, imageSrc, onClickBtnDelete, moveImage }: ImageItemPropsType) => {
  const boxRef = useRef<HTMLDivElement>(null)

  const [{ isDragging }, drag] = useDrag(() => ({
    type: PRODUCT_IMAGE,
    item: {
      index,
      imageSrc,
    },
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
  }))

  const [, drop] = useDrop({
    accept: PRODUCT_IMAGE,
    hover(item: unknown, monitor: DropTargetMonitor) {
      const draggedItem = item as { index: number } & ProductImageType
      if (!boxRef.current) return
      const dragIndex = draggedItem.index
      const hoverIndex = index
      if (dragIndex === hoverIndex) return
      const hoverBoundingRect = boxRef.current?.getBoundingClientRect()
      const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2
      const clientOffset = monitor.getClientOffset()
      if (!clientOffset) {
        return
      }
      const hoverClientY = clientOffset.y - hoverBoundingRect.top
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return
      }
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return
      }
      moveImage(dragIndex, hoverIndex)
      draggedItem.index = hoverIndex
    },
  })

  drag(drop(boxRef))

  return (
    <StyledBoxImage ref={boxRef} style={{ opacity: isDragging ? 0.4 : 1 }} key={`upload-${index}`}>
      <img
        src={imageSrc}
        alt={`Preview ${index + 1}`}
        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
      />

      <StyledOverlay>
        <Typography variant="body2" color="white" marginTop="5px">
          Geser gambar untuk mengurutkan
        </Typography>
      </StyledOverlay>
      <StyledIconButton onClick={() => onClickBtnDelete(index)}>
        <Trash />
      </StyledIconButton>
    </StyledBoxImage>
  )
}
export default ImageItem
